'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateResultDisplay = exports.sortColumn = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.getDateRange = getDateRange;
exports.generateAggregateEventTriggerDisplayName = generateAggregateEventTriggerDisplayName;
exports.generateAggregateEventDisplayName = generateAggregateEventDisplayName;
exports.generateAggregateEventDisplayTime = generateAggregateEventDisplayTime;
exports.generateEventEntityName = generateEventEntityName;
exports.getARLinkForEvent = getARLinkForEvent;
exports.generateEventStatus = generateEventStatus;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _isString = require('lodash/lang/isString');

var _isString2 = _interopRequireDefault(_isString);

var _antd = require('@adparlor-devops/antd');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sortColumn = exports.sortColumn = function sortColumn(key) {
  return function (a, b) {
    var sortA = a[key];
    var sortB = b[key];
    if ((0, _isString2.default)(sortA)) sortA = sortA.toLowerCase();
    if ((0, _isString2.default)(sortB)) sortB = sortB.toLowerCase();
    if (sortA < sortB) return -1;
    if (sortA > sortB) return 1;
    return 0;
  };
};

function getDateRange(params) {
  var dateFormat = 'YYYY-MM-DDTHH:mm:ss';
  var formatUTC = function formatUTC(value) {
    return value.utc().format(dateFormat);
  };
  var startTime = null;
  var endTime = null;

  switch (params && params.filterRange) {
    case 'TODAY':
      startTime = formatUTC((0, _moment2.default)().startOf('day'));
      endTime = formatUTC((0, _moment2.default)().endOf('day'));
      break;
    case 'YESTERDAY':
      startTime = formatUTC((0, _moment2.default)().startOf('day').subtract(1, 'days'));
      endTime = formatUTC((0, _moment2.default)().endOf('day').subtract(1, 'days'));
      break;
    case 'LAST_N_DAYS':
      startTime = formatUTC((0, _moment2.default)().startOf('day').subtract(params.lastNdays, 'days'));
      endTime = formatUTC((0, _moment2.default)().endOf('day'));
      break;
    case 'THIS_MONTH':
      startTime = formatUTC((0, _moment2.default)().startOf('month'));
      endTime = formatUTC((0, _moment2.default)().endOf('month'));
      break;
    case 'LAST_MONTH':
      startTime = formatUTC((0, _moment2.default)().subtract(1, 'months').startOf('month'));
      endTime = formatUTC((0, _moment2.default)().subtract(1, 'months').endOf('month'));
      break;
    case 'DATE_RANGE':
      startTime = formatUTC(params.startTime.startOf('day'));
      endTime = formatUTC(params.endTime.endOf('day'));
      break;
    default:
      // TODAY
      startTime = formatUTC((0, _moment2.default)().startOf('day'));
      endTime = formatUTC((0, _moment2.default)().endOf('day'));
      break;
  }
  return { startTime: startTime, endTime: endTime };
}

function generateAggregateEventTriggerDisplayName(_ref) {
  var origin = _ref.origin,
      actor = _ref.actor;

  switch (origin) {
    case _constants.RIPPLE_FACEBOOK_PLATFORM:
      return _constants.RULE_HIERARCHY.map(function (level) {
        var entity = actor.find(function (entityLevel) {
          return entityLevel.type === level;
        });
        return entity.name;
      }).join(' > ');
    case _constants.MONEYTALK_FACEBOOK_PLATFORM:
      return 'Auto-Import';
    case _constants.THUMBSUP_FACEBOOK_PLATFORM:
      return 'User-Initiated Import';
    default:
      return 'Unknown Trigger';
  }
}

function generateAggregateEventDisplayName(_ref2) {
  var count = _ref2.count,
      origin = _ref2.origin,
      affectedEntity = _ref2.affectedEntity,
      sampleResult = _ref2.sampleResult;

  var affectedEntityTypes = affectedEntity.map(function (entity) {
    return entity.type;
  });
  var lowestEntityLevel = _constants.ENTITY_LEVELS.find(function (entity) {
    return affectedEntityTypes.includes(entity);
  }) || "Campaign";
  var plurality = count === 1 ? '' : 's';

  if (origin === _constants.RIPPLE_FACEBOOK_PLATFORM && sampleResult) {
    var actionDesc = sampleResult.find(function (res) {
      return res.key === "actionDesc";
    });
    return actionDesc.value + ' for ' + count + ' ' + lowestEntityLevel + plurality;
  } else if (origin === _constants.MONEYTALK_FACEBOOK_PLATFORM || origin === _constants.THUMBSUP_FACEBOOK_PLATFORM) {
    return count + ' ' + lowestEntityLevel + plurality + ' Imported';
  }

  return count + ' ' + lowestEntityLevel + plurality + ' affected';
}

function generateAggregateEventDisplayTime(timestamp) {
  var date = _moment2.default.utc(timestamp).local();
  return date.format('MMM DD, YYYY - h:mma');
}

function generateEventEntityName(affectedEntity) {
  var eventEntityNameList = [];
  var firstEntity = true;

  _constants.ENTITY_LEVELS.filter(function (entity) {
    return entity !== 'Advertiser';
  }).forEach(function (entity) {
    var affected = affectedEntity.find(function (affectedE) {
      return affectedE.type === entity;
    });
    if (affected) {
      if (firstEntity) {
        eventEntityNameList.push('<span style="font-weight: bold; display: block;">' + affected.name + ' (' + affected.id + ')</span>');
        firstEntity = false;
      } else {
        eventEntityNameList.push('' + affected.name);
      }
    }
  });
  return eventEntityNameList[0] + ' ' + (eventEntityNameList.shift().length >= 1 ? eventEntityNameList.join(' > ') : '');
}

function getARLinkForEvent(sampleResult) {
  var arReportUrl = sampleResult.find(function (res) {
    return res.key === "arReportUrl";
  });
  return arReportUrl ? arReportUrl.value : null;
}

var generateResultDisplay = exports.generateResultDisplay = function generateResultDisplay(results) {
  var status = results.find(function (result) {
    return result.key === "status";
  });
  var statusReason = results.find(function (result) {
    return result.key === "statusReason";
  });
  var actionDesc = results.find(function (result) {
    return result.key === "actionDesc";
  });
  var NA_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Helpers.generateResultDisplay.NA.message', defaultMessage: 'N/A' });

  return _react2.default.createElement(
    _antd.Tooltip,
    { placement: 'left', title: statusReason && statusReason.value || actionDesc && actionDesc.value || '' },
    _constants.STATUS_LEVELS[status.value] && _constants.STATUS_LEVELS[status.value].displayValue || NA_MESSAGE
  );
};

function generateEventStatus(results) {
  var start = results.find(function (result) {
    return result.key === "startState";
  });
  var end = results.find(function (result) {
    return result.key === "endState";
  });
  var action = results.find(function (result) {
    return result.key === "action";
  });
  var status = results.find(function (result) {
    return result.key === "status";
  });
  var NA_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Helpers.N/A.message', defaultMessage: 'N/A' });

  var parseStartAndEndDecimal = function parseStartAndEndDecimal(object) {
    return object && object.value ? '$' + parseFloat(object.value).toFixed(2) : NA_MESSAGE;
  };
  var parseStartAndEndState = function parseStartAndEndState(object) {
    if (!object || !object.value) return NA_MESSAGE;
    var color = object.value === 'PAUSED' ? _constants.WARNING_COLOUR : _constants.SUCCESS_COLOUR;
    return _react2.default.createElement(
      'span',
      { style: { textTransform: 'capitalize', color: color } },
      object.value.toLowerCase()
    );
  };

  var rawValues = {
    start: start ? start.value : 'N/A',
    end: end ? end.value : 'N/A',
    result: status ? status.value : 'N/A'
  };

  switch (action.value) {
    case 'CHANGE_STATE':
      return (0, _extends3.default)({}, rawValues, {
        startDisplay: parseStartAndEndState(start),
        endDisplay: parseStartAndEndState(end),
        resultDisplay: generateResultDisplay(results)
      });
    case 'CHANGE_BID':
    case 'CHANGE_BUDGET':
      return (0, _extends3.default)({}, rawValues, {
        startDisplay: parseStartAndEndDecimal(start),
        endDisplay: parseStartAndEndDecimal(end),
        resultDisplay: generateResultDisplay(results)
      });
    case 'NOTIFY':
      return (0, _extends3.default)({}, rawValues, {
        startDisplay: NA_MESSAGE,
        endDisplay: NA_MESSAGE,
        resultDisplay: _constants.STATUS_LEVELS[status.value].displayValue
      });
    default:
      return (0, _extends3.default)({}, rawValues, {
        startDisplay: NA_MESSAGE,
        endDisplay: NA_MESSAGE,
        resultDisplay: NA_MESSAGE
      });
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/dear-diary/lib/helpers/index.js
// module id = 3414
// module chunks = 2